import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { Phone } from '@app/entities/interfaces/ptrab/shared/phone.interface';
import { TwoFactorOperationCode } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { Buttons } from '@app/entities/models/buttons/buttons';
import { ContentModalComponent } from '@app/presentation/components/modals/content-modal/content-modal.component';
import { ModalManager } from '@app/services';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

import { M_DIALOG_DATA } from '@mercadona/components-musi/dialog';
import { MTranslatePipe } from '@mercadona/core/translate';

import { ItemComponent } from '@/components/item/item.component';

@Component({
  selector: 'app-ptrab-second-fa-phone-selection',
  imports: [CommonModule, FormsModule, MTranslatePipe, ContentModalComponent, ItemComponent],
  templateUrl: './second-fa-phone-selection.component.html',
  styleUrls: ['./second-fa-phone-selection.component.scss']
})
export class SecondFaPhoneSelectionComponent implements OnInit {
  phones!: Phone[];

  selectedPhoneId!: string | null | undefined;
  reminderMessage!: string;
  isSinglePhone!: boolean;
  availablePhones!: Phone[];

  buttons: Buttons[] = [
    {
      text: 'TWO_FACTOR.VERIFY_NUMBER.NO_PHONE',
      type: 'ghost',
      enabled: true,
      onClick: () => this.modalManager.dismissMatModal(TwoFactorOperationCode.REQUEST_OTHER_PHONE)
    },
    {
      text: 'COMMON.NEXT',
      enabled: false,
      onClick: () => this.close(true)
    }
  ];

  constructor(
    @Inject(M_DIALOG_DATA) public data: MSafeAny,
    private modalManager: ModalManager
  ) {}

  ngOnInit() {
    this.phones = this.data.phones;

    this.availablePhones = this.phones.filter((phone) => phone.sms);
    this.isSinglePhone = this.availablePhones && this.availablePhones.length === 1;
    this.checkPhones();
  }

  get getUniquePhone(): Phone | undefined {
    return this.availablePhones.find((phone) => phone.sms);
  }

  close(withValue: boolean) {
    if (!withValue) {
      this.selectedPhoneId = null;
    }

    this.modalManager.dismissMatModal(this.selectedPhoneId);
  }

  setSelectedPhone(phoneId: string | undefined) {
    this.selectedPhoneId = phoneId;
    this.buttons[1].enabled = true;
  }

  private checkPhones() {
    this.reminderMessage = 'TWO_FACTOR.VERIFY_PHONE.REMEMBER';

    if (this.isSinglePhone) {
      this.setSelectedPhone(this.getUniquePhone?.id);
    }
  }
}
